<ui-dropdown [items]="envelopeActions()">
	<ui-button
		ariaLabel="More actions"
		preset="EXTRA_LOW_EMPHASIS"
		[size]="size()"
		icon="dots-vertical"
		matTooltip="More actions"
		matTooltipPosition="above"
		matTooltipShowDelay="500"
	/>
</ui-dropdown>
